var _desc, _defs, _rect, _path, _path2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificationConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 640,
    viewBox: "0 0 900 640",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Certification consultation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "An original illustration of a consultant reviewing certification documents.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f8fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0f2fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f766e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 18,
    floodColor: "#0f172a",
    floodOpacity: 0.16
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 640,
    rx: 34,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 112h772",
    stroke: "#bae6fd",
    strokeWidth: 2,
    strokeDasharray: "10 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 502c86-74 159-63 219-35 70 33 118 28 176-30 76-75 158-88 313-7",
    fill: "none",
    stroke: "#ccfbf1",
    strokeWidth: 36,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 92,
    width: 336,
    height: 420,
    rx: 22,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 148,
    width: 252,
    height: 26,
    rx: 13,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 204,
    width: 204,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 244,
    width: 230,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 284,
    width: 168,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 360,
    width: 112,
    height: 112,
    rx: 18,
    fill: "#ecfdf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 415 24 23 45-57",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608,
    cy: 416,
    r: 54,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 418h40M608 398v40",
    stroke: "#2563eb",
    strokeWidth: 12,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 260,
    width: 278,
    height: 204,
    rx: 22,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 302,
    width: 160,
    height: 20,
    rx: 10,
    fill: "#bfdbfe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 346,
    width: 206,
    height: 16,
    rx: 8,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 382,
    width: 174,
    height: 16,
    rx: 8,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 314,
    r: 28,
    fill: "url(#accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 315l10 10 18-24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 202,
    r: 58,
    fill: "#fef3c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 302c22-52 55-78 99-78 43 0 76 26 98 78",
    fill: "#0f766e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 207c20 22 51 27 81 6",
    fill: "none",
    stroke: "#92400e",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 194,
    r: 5,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 194,
    r: 5,
    fill: "#0f172a"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M568 540c42-50 122-52 169-6",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 26,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622,
    cy: 488,
    r: 34,
    fill: "#f8d7bc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 488,
    r: 34,
    fill: "#f8d7bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 557c18-48 43-72 75-72 32 0 58 24 78 72",
    fill: "#1d4ed8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationConsultation);
export default __webpack_public_path__ + "static/media/certification-consultation.066ce924772937ecb58f34f5d1c44547.svg";
export { ForwardRef as ReactComponent };